import { useFilePreviewQuery } from '@dieterApi/file/useFilePreviewQuery';
import { DocumentSkeleton } from '../OutputView/DocumentSkeleton';

interface Props {
  fileId: string;
  token?: string;
}

export function FileView({ fileId, token }: Props) {
  const { data, loading, error } = useFilePreviewQuery({ id: fileId, token });

  if (loading)
    return (
      <div className="p-12">
        <DocumentSkeleton />
      </div>
    );
  if (error) return <p className="p-6 text-sm text-red-600">{error.message}</p>;

  return (
    <div>
      {data?.getFilePreview.map((img) => (
        <img key={img} src={img} className="max-w-full" />
      ))}
    </div>
  );
}
